export default __webpack_public_path__ + "static/media/background-dark-2.8628d6cc.jpg";